import api from '@pray/shared/utils/api';

export type ArtistEmailActivity = {
  artist_id: number;
  artist_name: string;
  username: string;
  emails_sent: number;
  delivery_rate: number;
  bounce_rate: number;
  spam_rate: number;
  open_rate: number;
  click_rate: number;
};

export type EmailHealthActivityResponse = {
  artists: ArtistEmailActivity[];
};

export type GetEmailHealthActivityParams = {
  start_date: string;
  end_date: string;
};

export async function getEmailHealthActivity({
  start_date,
  end_date,
}: GetEmailHealthActivityParams): Promise<EmailHealthActivityResponse> {
  const params: Record<string, string> = { start_date, end_date };

  const url = '/web/studio/system-check/email-health/activity';
  const response = await api.executeGetRequest<{ data: EmailHealthActivityResponse }>(url, params);

  return response.data.data;
}
